import { render } from "./EnrolleeRemoveSingleOnboardComponent.vue?vue&type=template&id=013260f9&scoped=true"
import script from "./EnrolleeRemoveSingleOnboardComponent.vue?vue&type=script&lang=js"
export * from "./EnrolleeRemoveSingleOnboardComponent.vue?vue&type=script&lang=js"

import "./EnrolleeRemoveSingleOnboardComponent.vue?vue&type=style&index=0&id=013260f9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-013260f9"]])

export default __exports__